module.exports = __webpack_public_path__ + "img/2.e8259c54.jpg";